<template>
  <div class="min-h-screen bg-legal-50">
    <!-- Main content area - full width since sidebar is handled by specific layouts -->
    <div class="flex flex-col min-h-screen">

      <!-- Breadcrumb removed in Navigation Footer Implementation Phase 3 -->
      <!-- Navigation simplified to use browser back and Nav.vue central island -->

      <!-- Main content -->
      <main class="flex-1 overflow-x-hidden">
        <router-view />
      </main>

      <!-- Footer -->
      <PublicFooter class="flex-shrink-0" />
    </div>
  </div>
</template>

<script setup>
import PublicFooter from './PublicFooter.vue'
// AppHeader and AppSidebar removed - navigation handled by specific layouts (AdminLayoutBase, etc.)
// Breadcrumb removed - component eliminated in Phase 3 Navigation Footer Implementation
// This layout is simplified - only provides container and footer for basic routes
</script>

<style scoped>
@reference "../../assets/styles/main.css";

/* Additional layout styles */
.sidebar-transition {
  @apply transition-transform duration-300 ease-in-out;
}

/* Mobile overlay styles */
.overlay-enter-active, .overlay-leave-active {
  @apply transition-opacity duration-300;
}

.overlay-enter-from, .overlay-leave-to {
  @apply opacity-0;
}
</style>
